import { BallType, TicketType } from './enums';

export const FONT_BALOO_NAME = 'Baloo 2';
export const FONT_LATO_NAME = 'Lato';
export const DEMO_BALANCE = 1000_000_000;
export const PAGE_TAB_IN_ACTIVE_TIME = 1_800_000;
export const BONUS_COST_MULTIPLIER = 100;
// export const PAGE_TAB_IN_ACTIVE_TIME_BONUS_CASE = 5000;


export const bonusInfoByTicketType = {
  [TicketType.red]: [5, 3],
  [TicketType.green]: [10, 1],
  [TicketType.blue]: [3, 5],
};

export const colors = [
  BallType.pink,
  BallType.magenta,
  BallType.green,
  BallType.yellow,
  BallType.pink,
  BallType.magenta,
  BallType.green,
  BallType.yellow,
];

export const RtlLanguages = ['fa', 'ar', 'per', 'ara'];